<template>
    <az-container>
        <az-form>
            <div class="li-tabela">
                <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                              :pagination.sync="paginacaoInterna" :loading="false"
                              no-data-text="Não há credenciamentos cadastrados" :style="cssVar"
                              hide-actions class="az-table-list table-licitacoes">
                    <template slot="items" slot-scope="props">
                      <td>
                        {{ props.item.dataAbertura | az-date('DD/MM/YYYY HH:mm:ss')}}
                      </td>
                        <td>
                            <span v-if="props.item.numeroEdital">
                              <span v-if="modoCriacao === 'IMPORTAR' || modoCriacao === 'DESABILITADO'">E - </span>{{ props.item.numeroEdital }}
                            </span>
                            <span v-if="(modoCriacao === 'IMPORTAR' || modoCriacao === 'DESABILITADO') && props.item.numProcesso">
                              <p>
                                <strong>P - {{props.item.numProcesso }}</strong>
                              </p>
                            </span>
                            <span v-if="props.item.numRepeticao > 0">
                                <strong>
                                    <p>Repetição {{ props.item.numRepeticao }}</p>
                                </strong>
                            </span>
                        </td>
                      <td v-if="props.item.dataLimiteEsclarecimentoImpugnacao">
                        {{ props.item.dataLimiteEsclarecimentoImpugnacao | az-date('DD/MM/YYYY HH:mm:ss') }}
                      </td>
                      <td v-else>
                        --
                      </td>
                        <td>
                            <span v-if="props.item.modalidade">
                                {{ getModalidadeLicitacao(props.item.modalidade) }}
                            </span>
                            <span v-else><strong>--</strong></span>
                        </td>
                        <td>
                            <expandir-texto :texto="props.item.objeto" tamanho="150"></expandir-texto>
                        </td>
                        <td>
                        <span v-if="props.item.orgao" :title="props.item.orgao.nome">
                            {{ props.item.orgao.sigla }}
                        </span>
                          <span v-else><strong>--</strong></span>
                        </td>
                        <td v-if="!isFornecedor">
                          <v-tooltip top v-az-auth="'Credenciamento.Visualizar'">
                            <a slot="activator" target="_blank" style="text-decoration: none"
                               @click="baixarRelatorioDownloadEdital(props.item)">
                              <v-icon>get_app</v-icon>
                            </a>
                            Baixar Relatório de Downloads
                          </v-tooltip>
                          <span style="padding-left: 5px;">{{props.item.quantidadeDownload || 0}}</span>
                        </td>
                        <td v-if="props.item.modalidade === 'CREDENCIAMENTO'">
                          <span>{{ obterSituacaoLicitacao(props.item) }}</span>
                        </td>
                        <td v-else :class="{'status-active': props.item.publicado, 'status': !props.item.publicado}">
                            <a @click="acessarPregao(props.item)"
                               v-if="props.item.publicado && props.item.executarLicitacao && isUsuarioComDominio && !acessoFornecedorLicitacaoPresencial(props.item)">
                                {{props.item.status | statusLicitacao }}
                                <v-icon>play_arrow</v-icon>
                                <v-tooltip v-if="props.item.status === 'SUSPENSO' && isFornecedor" top max-width="600">
                                  <span slot="activator">
                                    <v-icon size="20" class="align-center" style="margin-bottom: 3px; transform: rotate(180deg);">
                                      info
                                    </v-icon>
                                  </span>
                                  {{props.item.motivoSuspensao || 'Motivo não disponível'}}
                                </v-tooltip>
                            </a>
                            <span v-if="props.item.publicado && props.item.executarLicitacao && !isUsuarioComDominio && !acessoFornecedorLicitacaoPresencial(props.item)">
                              {{props.item.status | statusLicitacao}}
                            </span>
                            <span v-else-if="props.item.publicado && !props.item.executarLicitacao || acessoFornecedorLicitacaoPresencial(props.item)">Publicado</span>
                            <span v-if="!props.item.publicado">Em Elaboração</span>
                        </td>
                        <td>
                              <span>
                                  {{ props.item.resultado }}
                              </span>
                        </td>
                        <td class="this-table-actions">
                            <v-tooltip v-if="props.item.linkAcessoExternoLicitante && props.item.status == 'AGUARDANDO_ABERTURA'" top v-az-auth="'Proposta.Atualizar'">
                              <a slot="activator" @click="acessarPregaoProposta(props.item)">
                                <v-icon class="blob laranja">monetization_on</v-icon>
                              </a>
                              Lançar Proposta
                            </v-tooltip>
                            <v-tooltip v-if="props.item.linkAcessoExterno" top max-width="350px">
                              <a slot="activator" @click="acessarPregao(props.item)"><v-icon class="blob laranja" color="orange" aria-hidden="true">info</v-icon></a>
                              <span>Este credenciamento foi criada no SGC, ao acessar você será direcionado para o sistema antigo.</span>
                            </v-tooltip>
                            <v-tooltip v-else top v-az-auth="'Credenciamento.Visualizar,Credenciamento.Fornecedor'">
                                <a slot="activator" @click="$emit('visualizar',props.item.id)">
                                    <v-icon>search</v-icon>
                                </a>
                                {{labelAcaoVisualizar}}
                            </v-tooltip>
                            <v-tooltip v-if="!props.item.linkAcessoExterno && props.item.acessoEditar && !isFornecedor" top class="no-mobile" v-az-auth="'Credenciamento.Editar'">
                                <a slot="activator" @click="$emit('editar',props.item.id)">
                                    <v-icon>edit</v-icon>
                                </a>
                                Editar
                            </v-tooltip>
                            <v-tooltip v-if="props.item.editalUri" top v-az-auth="'Credenciamento.Visualizar,Credenciamento.Fornecedor'">
                                <a slot="activator" target="_blank" style="text-decoration: none"
                                   @click="baixarArquivo(props.item)"
                                   v-show="isFornecedor">
                                    <v-icon>get_app</v-icon>
                                </a>
                                Baixar Edital
                            </v-tooltip>
                            <v-tooltip top v-if="exibirBotaoPncp(props.item)" v-az-auth="'Credenciamento.Editar','Credenciamento.Visualizar'">
                              <a slot="activator" @click="$emit('acessarPncp', props.item)">
                                  <v-icon>open_in_new</v-icon>
                              </a>
                              Acessar no PNCP
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.mensagemErroIntegracao">
                              <a slot="activator">
                                <v-icon class="icon-alert-pncp" color="orange" aria-hidden="true">warning</v-icon>
                                <span class="acao-mobile">{{props.item.mensagemErroIntegracao}}</span>
                              </a>
                              {{props.item.mensagemErroIntegracao}}
                            </v-tooltip>
                            <v-tooltip top v-if="recursoSemResposta(props.item) || contrarrazaoSemResposta(props.item)" v-az-auth="'Credenciamento.Editar'">
                              <a slot="activator" @click="$emit('abrirRecursosContrarrazoes',props.item.id)">
                                <v-icon color="orange">info</v-icon>
                              </a>
                              Este processo possui
                              <span v-if="recursoSemResposta(props.item) && contrarrazaoSemResposta(props.item)">
                                <strong>recurso</strong> e <strong>contrarrazão</strong> <br>
                              </span>
                              <span v-if="recursoSemResposta(props.item) && !contrarrazaoSemResposta(props.item)">
                                <strong>recurso</strong>
                              </span>
                              <span v-if="!recursoSemResposta(props.item) && contrarrazaoSemResposta(props.item)">
                                <strong>contrarrazao</strong>
                              </span>
                              aguardando resposta, clique para visualizar
                            </v-tooltip>
                        </td>
                        <td v-if="props.item.existeEsclarecimentoImpugnacao && !isFornecedor" style="width: 5px">
                          <v-tooltip top>
                            <a slot="activator">
                              <v-icon class="blub azul" color="blue" aria-hidden="true">info</v-icon>
                            </a>
                            <span>Este credenciamento possui esclarecimento/impugnação.</span>
                          </v-tooltip>
                        </td>
                        <td v-else-if="!isFornecedor" style="width: 5px">
                        </td>
                    </template>
                </v-data-table>
                <div class="az-pagination">
                    <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                    <div class="az-select-pagination">
                        <span>Linhas por página:</span>
                        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                    </div>
                </div>
            </div>
        </az-form>
    </az-container>
</template>
<script>
    import {mapState} from 'vuex'
    import ExpandirTexto from '@/commons/components/ExpandirTexto'
    import {actionTypes, modalidadesLicitacao} from "@/commons/constants";
    import moment from 'moment'

    export default {
        components: {ExpandirTexto},
        props: ['itens', 'paginacao', 'paginas', 'totalItens', 'modoCriacao'],
        data() {
            return {
                modalidadesLicitacao,
                paginacaoInterna: this.paginacao,
                linhasPorPagina: [10, 25, 50, 100],
                pollingTimer: null,
                colunas: [
                    {
                        text: 'Data/Hora Abertura',
                        value: 'dataAbertura',
                        sortable: false,
                        align: 'left',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: this.tituloColunaEdital,
                        value: 'numeroEdital',
                        sortable: false,
                        align: 'left',
                        width: '170px',
                        class: 'primary--text'
                    },
                    {
                      text: 'Limite Esclarecimento',
                      value: 'dataEsclarecimentoImpugnacao',
                      sortable: false,
                      align: 'left',
                      width: '25px',
                      class: 'primary--text'
                    },
                    {
                        text: 'Modalidade',
                        value: 'modalidade',
                        sortable: false,
                        align: 'left',
                        width: '40px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Objeto',
                        value: 'objeto',
                        sortable: false,
                        align: 'left',
                        width: '180px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Responsável',
                        value: 'orgao.nome',
                        sortable: false,
                        align: 'left',
                        width: '80px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        sortable: false,
                        align: 'left',
                        width: '120px',
                        class: 'primary--text'
                    },
                    {
                      text: 'Resultado',
                      value: 'resultado',
                      sortable: false,
                      align: 'left',
                      width: '120px',
                      class: 'primary--text'
                    },
                    {
                        text: 'Ações',
                        sortable: false,
                        align: 'left',
                        width: '110px',
                        class: 'primary--text'
                    }
                ]
            }
        },
        created() {
          this.colunas[1].text = this.tituloColunaEdital
          if (!this.isFornecedor) {
            this.colunas.splice(6,0,{
              text: 'Nº Downloads',
              value: 'quantidadeDownloads',
              sortable: false,
              align: 'left',
              width: '110px',
              class: 'primary--text'
            })
          }
        },
        mounted(){
          this.startPolling()
        },
        beforeDestroy(){
          this.stopPolling()
        },
        methods:{
          startPolling(){
            if (this.pollingTimer) return
            if (this.itens && this.itens.some(item => this.ehCredenciamentoAguardandoAbertura(item))) {
              this.pollingTimer = setInterval(() => {
                const aindaAguardando = this.itens && this.itens.some(item => this.ehCredenciamentoAguardandoAbertura(item))
                if (!aindaAguardando) {
                  this.$emit('paginar', this.paginacaoInterna)
                  this.stopPolling()
                }
              }, 5000)
            }
          },
          stopPolling(){
            if (this.pollingTimer) {
              clearInterval(this.pollingTimer)
              this.pollingTimer = null
            }
          },
          exibirBotaoPncp(licitacao){
            return licitacao.sequencialCompraPublica && licitacao.publicado
          },
          recursoSemResposta(licitacao){
            return licitacao.existeRecursoSemResposta && !this.$store.state.parametros.propriedadesLicitacao.ehPerfilComprasBR
          },
          contrarrazaoSemResposta(licitacao){
            return licitacao.existeContrarrazaoSemResposta && !this.$store.state.parametros.propriedadesLicitacao.ehPerfilComprasBR
          },
          getModalidadeLicitacao(modalidade){
            return this.modalidadesLicitacao[modalidade]
          },
          acessoFornecedorLicitacaoPresencial(licitacao) {
            return this.isFornecedor && licitacao.modalidade.includes('PRESENCIAL')
          },
          async baixarArquivo(licitacao) {
            const doc = licitacao.edital
            const payload = {
              licitacaoId: licitacao.id,
              documentoVirtualizadoId: doc.idVirtualizado,
              nomeArquivo: doc.arquivoNome,
              externo: doc.externo,
              uri: doc.arquivoUri,
              tipoAnexo : doc.tipo
            }
            await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_ARQUIVO_USUARIO_LOGADO, payload)
          },
          async baixarRelatorioDownloadEdital(licitacao) {
            if(licitacao.quantidadeDownload === 0) {
                this.mostrarNotificacaoErro("Nenhum download foi realizado deste documento.")
            }
            const doc = licitacao.edital
            const payload = {
              idLicitacao: licitacao.id,
              uriArquivo: doc.arquivoUri
            }
            await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_DOWNLOAD_EDITAL, payload)
          },
          obterSituacaoLicitacao(item) {
            if (item.publicado) {
              if (this.ehCredenciamentoAguardandoAbertura(item)) {
                return 'Ag. Abertura'
              } else {
                return 'Aberto'
              }
            } else {
              return 'Em Elaboração'
            }
          },
          ehCredenciamentoAguardandoAbertura(item) {
            if (item && item.publicado) {
              const dataAbertura = moment(item.dataAbertura)
              const agora = moment(new Date())
              return agora.isBefore(dataAbertura)
            }
            return false
          },
          ehCredenciamentoPassouAbertura(item) {
            if (item && item.publicado) {
              const dataAbertura = moment(item.dataAbertura)
              const agora = moment(new Date())
              return agora.isSameOrAfter(dataAbertura)
            }
            return false
          }
        },
        computed: {
            isUsuarioComDominio() {
                return this.loki.user.domainId
            },
            labelAcaoVisualizar() {
                return this.isServidorPublico ? 'Visualizar' : 'Ver detalhes'
            },
            tituloColunaEdital(){
                if(this.modoCriacao === 'IMPORTAR' || this.modoCriacao === 'DESABILITADO'){
                  return 'Edital/Processo'
                }
                return 'Num. Edital'
            },
            cssVar() {
              return {
                '--label-coluna-edital': `"${this.tituloColunaEdital}"`
              }
            },
            ...mapState(['loki'])
        },
        watch: {
            paginacaoInterna: {
                handler(novoValor) {
                    this.$emit('paginar', novoValor)
                },
                deep: true
            },
            itens(newVal){
              this.stopPolling()
              if (newVal && newVal.some(item => this.ehCredenciamentoAguardandoAbertura(item))) {
                this.startPolling()
              }
            }
        }
    }
</script>
<style scoped lang="stylus">
    .status
        span
            color: #777777

            i
                display: none

    .status-active
        a
            text-decoration: none
            position: relative
            top: -5px
            color: #c6762b !important

            i
                position: relative
                top: 5px
                font-size: 26px
                color: #c6762b !important
                text-decoration: none

    .table-licitacoes
      .acao-mobile
        display none

      td:hover
        cursor pointer !important

    @media (max-width: 720px)
        .table-licitacoes
            td:nth-of-type(1):before
                content: "Data/Hora Abertura:"

            td:nth-of-type(2):before
              content: var(--label-coluna-edital)

            td:nth-of-type(3):before
                content: "Objeto:"

            td:nth-of-type(4):before
                content: "Responsável:"

            td:nth-of-type(5):before
                content: "Situação:"

            td:nth-of-type(6):before
                display none

            .acao-mobile
              display inline-block
              margin-left 3px

        .this-table-actions
            text-align: left !important;

            i
                font-size 20px !important

            a
                margin 0 !important

        .az-table-list tbody tr td
            padding: 2px 10px !important

        .status-active
            a
                text-decoration: none
                color: #777 !important
                position: relative
                top: 0

                i
                    display none

    .blob {
      border-radius: 50%;
      margin: 10px;
      height: 14px;
      width: 14px;
      transform: scale(1);
    }

    .blob.laranja {
      box-shadow: 0 0 0 0 rgba(255, 121, 63, 1);
      animation: pulse-laranja 2s infinite;
    }

    @keyframes pulse-laranja {
      0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 121, 63, 0.7);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 121, 63, 0);
      }

      100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 121, 63, 0);
      }
    }

    .blub {
      border-radius: 50%;
      margin: 10px;
      height: 14px;
      width: 14px;
      transform: scale(1);
    }

    .azul {
      box-shadow: 0 0 0 0 rgba(33, 150, 243, 1);
      animation: pulse-azul 2s infinite;
    }

    @keyframes pulse-azul {
      0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(33, 150, 243, .8);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(33, 150, 243, 0);
      }

      100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
      }
    }


</style>
